
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { showErrorSnackbar } from '../../../../../features/helpers/alerts-popups';

const DUPLICATE_NAME_MSG = 'Ingrese un nuevo nombre para el ítem';

@Component({})
export default class ModalCreateItem extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: Object, default: null }) claimInfo!: { ranch: { name: string } } | null;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Number, default: 0 }) selectedPolygonsCount!: number;

  localNewItemId: string = '';
  nameError: string = '';

  get originItemName(): string {
    return (this.claimInfo && this.claimInfo.ranch && this.claimInfo.ranch.name) ? this.claimInfo.ranch.name : '';
  }

  get isNameDuplicate(): boolean {
    const trimmed = (this.localNewItemId || '').trim();
    return trimmed !== '' && trimmed === this.originItemName;
  }

  get canSave(): boolean {
    const trimmed = (this.localNewItemId || '').trim();
    return trimmed !== '' && !this.isNameDuplicate && this.selectedPolygonsCount > 0;
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (val) {
      this.localNewItemId = this.originItemName;
      this.nameError = this.originItemName ? DUPLICATE_NAME_MSG : '';
    }
  }

  @Watch('claimInfo', { immediate: true })
  onClaimInfoChange() {
    if (this.visible) {
      this.localNewItemId = this.originItemName;
      this.nameError = (this.localNewItemId || '').trim() === this.originItemName && this.originItemName ? DUPLICATE_NAME_MSG : '';
    }
  }

  onInput() {
    this.nameError = this.isNameDuplicate ? DUPLICATE_NAME_MSG : '';
  }

  onCancel() {
    this.$emit('close');
  }

  onSave() {
    const trimmed = (this.localNewItemId || '').trim();
    if (trimmed === '') return;
    if (trimmed === this.originItemName) {
      showErrorSnackbar(DUPLICATE_NAME_MSG);
      this.nameError = DUPLICATE_NAME_MSG;
      return;
    }
    if (this.selectedPolygonsCount === 0) return;
    this.$emit('save', trimmed);
  }
}
